import {createReducer} from "typesafe-actions";
import {SWITCH_DEFAULT_LINE_STEP, SWITCH_DEFAULT_LIVE_STEP} from "../actions";

export const enableDefaultLineStep = createReducer(false).handleAction(SWITCH_DEFAULT_LINE_STEP, (s, a) => a.payload);

export const enableDefaultLiveStep = createReducer(false).handleAction(SWITCH_DEFAULT_LIVE_STEP, (s, a) => a.payload);